/* eslint-disable no-restricted-syntax */
export interface AuthData {
    /**
     * Token / access token
     */
    token?: string;
    idToken?: string;
    tokenExpiration?: string;
    refreshToken?: string;
    nonce?: string;
    clientId?: string;
    sid?: string;
    sessionState?: string;
    codeVerifier?: string;
}

const EMPTY_AUTH_DATA: AuthData = {};
const SESSION_STORAGE_KEY = 'authData';

export const getAuthData = <T extends AuthData = AuthData>(): T => {
    const authData = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (!authData) {
        return EMPTY_AUTH_DATA as T;
    }

    return JSON.parse(authData);
};

export const setAuthData = <T extends AuthData = AuthData>(authData?: T): void =>
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(authData ?? EMPTY_AUTH_DATA));

export const getTokenFromAuthData = (): string => getAuthData()?.token ?? '';
export const hasAuthDataToken = (): boolean => !!getTokenFromAuthData();

export const clearAuthData = (): void => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
};
